var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.86328C2.54167 5.86328 2.12311 5.75154 1.74432 5.52805C1.36553 5.30078 1.0625 4.99775 0.835227 4.61896C0.611742 4.24018 0.5 3.82161 0.5 3.36328C0.5 2.90116 0.611742 2.4826 0.835227 2.1076C1.0625 1.72881 1.36553 1.42768 1.74432 1.20419C2.12311 0.976918 2.54167 0.863281 3 0.863281C3.46212 0.863281 3.88068 0.976918 4.25568 1.20419C4.63447 1.42768 4.93561 1.72881 5.15909 2.1076C5.38636 2.4826 5.5 2.90116 5.5 3.36328C5.5 3.82161 5.38636 4.24018 5.15909 4.61896C4.93561 4.99775 4.63447 5.30078 4.25568 5.52805C3.88068 5.75154 3.46212 5.86328 3 5.86328Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.671f8303b36529bdda94d0dc4efe9c83.svg";
export { ForwardRef as ReactComponent };